import React from 'react';

const Info: React.FC = () => {
  return (
    <div className="info">
      <h2>About</h2>
      <p>
        This is a reimplementation of Gabriele Cirulli's excellent{' '}
        <a href="https://play2048.co/">2048</a> game, built with React, Redux
        and TypeScript. Unlike other React-based implementations, only
        functional components are used here. This project doesn't rely on canvas
        or element refs.
      </p>
    </div>
  );
};

export default Info;
